"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const auth_session_util_1 = require("../../../@common/util/auth-session-util");
const gatekeeper_api_1 = __importDefault(require("../../api/gatekeeper-api"));
const login_util_1 = require("./login-util");
const BaseStudentAppStrategy = ({ appName, loginUrl }) => ({
    authValue: (0, auth_session_util_1.getAuthSession)(),
    authenticate: gatekeeper_api_1.default.validateSession,
    getUser: null,
    loginUrl: loginUrl ? loginUrl : (0, login_util_1.getLoginAppUrl)(appName)
});
exports.default = BaseStudentAppStrategy;
